<div
  class="row"
  *ngIf="!WL.getI(namespace + '.hidden') && !(isMenuHidden | async)"
>
  <div
    class="col"
    *ngIf="menuItems$ | async as items"
    [class.mb-4]="items && items.length"
  >
    <ul
      class="nav nav-tabs nav-overflow"
      [class.border-0]="items && !items.length"
    >
      <ng-container *ngFor="let link of items">
        <li
          class="nav-item {{ link.class_li }}"
          [class.dropdown]="link.dropdown"
          [class.position-static]="link.dropdown"
          *appIfWl="!(isHidden(link.hidden) | async); key: getNS(link)"
          ngbDropdown
          placement="{{ link.placement || 'bottom-center' }}"
        >
          <a
            style="cursor: pointer"
            (click)="!!link.func()"
            [ngbTooltip]="link.tooltip | async"
            *ngIf="!link.dropdown && link.func"
            class="nav-link text-secondary {{ link.class_a }}"
            [id]="link.id || ''"
            (click)="isCollapsed = !isCollapsed"
            [class.active]="!!link.active && link.active()"
          >
            <i [class]="iconClass" *ngIf="link.class | async as iconClass"></i>
            {{ link.name | translate }}
          </a>

          <a
            style="cursor: pointer"
            *ngIf="!link.dropdown && !link.func"
            class="nav-link text-secondary"
            [id]="link.id || ''"
            [routerLink]="link.path"
            [class.active]="!!link.active && link.active()"
          >
            <i [class]="iconClass" *ngIf="link.class | async as iconClass"></i>
            {{ link.name | translate }}
          </a>

          <a
            (click)="(false)"
            href=""
            class="nav-link dropdown-toggle text-secondary"
            [id]="link.id || ''"
            *ngIf="link.dropdown"
            ngbDropdownToggle
          >
            <i [class]="iconClass" *ngIf="link.class | async as iconClass"></i>
            {{ link.name | translate }}
            <span class="caret"></span>
          </a>
          <ng-container *ngIf="link.dropdown">
            <div class="dropdown-menu" ngbDropdownMenu>
              <ng-container *ngFor="let subLink of link.dropdown">
                <ng-container
                  *appIfWl="
                    !(isHidden(subLink.hidden) | async);
                    key: getNS(link, subLink)
                  "
                >
                  <div class="dropdown-divider" *ngIf="subLink.divider"></div>

                  <a
                    style="cursor: pointer"
                    class="dropdown-item text-secondary"
                    [id]="subLink.id || ''"
                    (click)="!!subLink.func()"
                    *ngIf="!subLink.divider && subLink.func"
                    (click)="isCollapsed = !isCollapsed"
                  >
                    <i
                      [class]="sublinkIconClass"
                      *ngIf="subLink.class | async as sublinkIconClass"
                    ></i>
                    {{ subLink.name | translate }}
                  </a>

                  <a
                    style="cursor: pointer"
                    class="dropdown-item text-secondary"
                    [id]="subLink.id || ''"
                    [routerLink]="subLink.path"
                    *ngIf="!subLink.divider && !subLink.func && !subLink.header"
                    (click)="isCollapsed = !isCollapsed"
                  >
                    <i
                      [class]="sublinkIconClass"
                      *ngIf="subLink.class | async as sublinkIconClass"
                    ></i
                    >{{ subLink.name | translate }}
                  </a>

                  <p
                    class="text-secondary mt-1 mb-0 ml-4 mb-1 ng-star-inserted text-uppercase"
                    *ngIf="subLink.header"
                  >
                    <small>{{ subLink.name | translate }}:</small>
                  </p>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </li>
      </ng-container>
    </ul>

    <!-- Overflow scroller -->
    <!-- <i
      class="fe fe-arrow-right"
      style="
        position: absolute;
        right: 6px;
        top: 0px;
        height: 55px;
        width: 30px;
        padding: 19px 0 0 10px;
        background: var(--background);
        cursor: pointer;
      "
    ></i> -->
    <!--
      el.scroll({left: -100, top: 0, behavior: 'smooth'})
     -->
  </div>
</div>
